import { BetweenDates } from "../Betweendates";

export default function BirthDate({ searchObject, setSearchObject, t }) {
  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Birth date")}</legend>
        <BetweenDates
          setObeject={setSearchObject}
          dateObject={searchObject}
          dateEndField="birthDateEnd"
          dateStartField="birthDateStart"
        />
      </div>
    </>
  );
}
